<script>
/* COMPOSANTS */
import {Icon} from '@iconify/vue';
import AkButtonValidation from '@components/v2/general/AkButtonValidation.vue';
import AkButtonValidationV2 from '@components/v2/general/AkButtonValidationV2.vue';

/* MIXINS */

/* SERVICES */

export default {
  components: {AkButtonValidationV2, AkButtonValidation, Icon},
  props: {
    title: {type: String, required: true},
    width: {type: String, default: '400px'},
    message: {type: String, required: true},
    loadable: {type: Boolean, required: false, default: false},
    autoHideOnValidate: {type: Boolean, default: false},
  },
  emits: ['show', 'hide', 'yes', 'no'],
  data() {
    return {
      display: false,
    };
  },
  mounted() {},
  methods: {
    performYes(event) {
      if (event === undefined) return;
      if (this.loadable) this.$refs.btnYes.load();
      if (this.autoHideOnValidate) this.setDisplay(false);
      this.$emit('yes');
    },
    performNo(event) {
      if (event === undefined) return;
      this.hide();
      this.$emit('no');
    },
    show() {
      this.setDisplay(true);
      this.$emit('show');
    },
    hide() {
      this.setDisplay(false);
      this.$emit('hide');
    },
    init() {
      if (this.$refs.btnYes) this.$refs.btnYes.init();
    },
    setDisplay(value) {
      this.display = value;
    },
  },
};
</script>

<template>
  <PDialog
    v-model:visible="display"
    :modal="true"
    :style="{width: width}"
    @hide="hide()"
    class="dialog-headless delete">
    <div class="flex flex-col w-full items-center gap-8">
      <i
        class="ga-icon ga-trash text-red rounded-full h-[88px] w-[88px] flex items-center justify-center text-[40px] bg-red-50 p-6"></i>

      <div class="flex flex-col items-center gap-4">
        <span class="text-grey-900 font-bold text-md">{{ title }}</span>
        <span class="text-grey-900 font-base text-base text-center">{{ message }}</span>
      </div>
    </div>

    <template #footer>
      <div class="flex gap-4 w-full">
        <span class="btn-secondary-inverse flex-1" @click="performNo">
          {{ $t('cancel') }}
        </span>
        <AkButtonValidationV2 ref="btnYes" class="btn-blue flex-1" @click="performYes" :label="$t('validate')" />
      </div>
    </template>
  </PDialog>
</template>
